import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/common/assets/icon/Vector.png'


const _hoisted_1 = { class: "wrapper-camera" }
const _hoisted_2 = { class: "__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = {
  id: "cameraPreview",
  class: "cameraPreview"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "camera-content" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "actions text-center row w-full flex-wrap flex items-center justify-around" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-back",
        onClick: _cache[0] || (_cache[0] = 
          () => {
            _ctx.stopCamera();
            _ctx.resetCapture();
          }
        )
      }, _hoisted_4),
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.information.title), 1)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.information.description), 1),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.photoPreview)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "img-preview",
            src: `data:image/jpeg;base64,${_ctx.photoPreview}`
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.information.cardName), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (!_ctx.photoPreview)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "capture",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.capturePhoto && _ctx.capturePhoto(...args)))
          }))
        : _createCommentVNode("", true),
      (!_ctx.photoPreview)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "switch-camera",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.switchCam && _ctx.switchCam(...args)))
          }, [
            _createVNode(_component_ion_icon, { icon: _ctx.cameraReverseOutline }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.photoPreview)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "use-photo mb-2",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.takePhoto && _ctx.takePhoto(...args)))
          }, "Use photo"))
        : _createCommentVNode("", true),
      (_ctx.photoPreview)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: "use-photo mb-2",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetCapture && _ctx.resetCapture(...args)))
          }, " Capture photo "))
        : _createCommentVNode("", true)
    ])
  ]))
}